import PmiStructureEnum from '@constants/enums/pmi/structure';

import i18n from '@plugins/i18n';

import { HoldingCollection, Holding } from '@/models';

export class InvestmentsPmiFundPanelCollection extends HoldingCollection {
    static type = 'InvestmentsPmiFundPanelCollection';
    static endpoint = Holding.api.byPrivateMarketStructure;

    static fields() {
        return {
            ...super.fields(),
            holding_id: this.string(null).nullable()
        };
    }

    get default_headers() {
        return [
            'investor.name',
            'invested_on',
            'total_invested',
            'invested_amount',
            'cash_balance',
            'current_value',
            'total_return',
            'total_return_moic',
            'total_return_percentage',
            'total_return_including_tax_relief',
            'total_return_including_tax_relief_moic',
            'total_return_including_tax_relief_percentage'
        ];
    }

    get preset_filters() {
        let filters = {};

        if (this.investor_id) {
            filters.investor_id = this.filterOperator('is') + ':' + this.investor_id;
        }

        if (this.show_consolidated_view) {
            filters.consolidated = true;
        }

        if (this.status) {
            filters.status = this.filterOperator('is') + ':OPEN';
        }

        if (this.holding_id) {
            filters.holding_id = this.filterOperator('is') + ':' + this.holding_id;
        }

        filters.structure = this.filterOperator('is') + ':' + PmiStructureEnum.FUND;

        return filters;
    }

    get headers() {
        return [
            this.createHeader('investor.name', i18n.tc('investor'), {
                path: 'investor.name',
                width: '18rem',
                minWidth: '14rem',
                sortable: true
            }),
            this.createHeader('invested_on', i18n.t('application_on'), {
                format: 'date',
                width: '8rem',
                sortable: true
            }),
            this.createHeader('total_invested', i18n.t('gross_investment_value'), {
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                sortable: true,
                filterable: true
            }),
            this.createHeader('invested_amount', i18n.t('total_invested'), {
                format: 'money',
                formatOptions: this.money_format_options,
                width: '11rem',
                sortable: true,
                filterable: true
            }),
            this.createHeader('cash_balance', i18n.t('cash_balance'), {
                format: 'money',
                formatOptions: this.money_format_options,
                width: '11rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader('current_value', i18n.t('current_value'), {
                column: 'current_value',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader('total_return', i18n.t('total_return'), {
                column: 'total_return',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader('total_return_moic', i18n.t('total_return_moic'), {
                column: 'total_return_moic',
                format: 'number',
                formatOptions: {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                },
                append: 'X',
                width: '8rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader('total_return_percentage', i18n.t('total_return_percentage'), {
                column: 'total_return_percentage',
                format: 'percentage',
                formatOptions: this.percentage_format_options,
                width: '9.2rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader('total_return_including_tax_relief', i18n.t('total_return_including_tax_relief'), {
                column: 'total_return_including_tax_relief',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9.2rem',
                sortable: true,
                filterable: true
            }),

            this.createHeader(
                'total_return_including_tax_relief_moic',
                i18n.t('total_return_including_tax_relief_moic'),
                {
                    column: 'total_return_including_tax_relief_moic',
                    format: 'number',
                    formatOptions: {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    },
                    append: 'X',
                    width: '11rem',
                    sortable: true,
                    filterable: true
                }
            ),

            this.createHeader(
                'total_return_including_tax_relief_percentage',
                i18n.t('total_return_including_tax_relief_percentage'),
                {
                    column: 'total_return_including_tax_relief_percentage',
                    format: 'percentage',
                    formatOptions: this.percentage_format_options,
                    width: '10.2rem',
                    sortable: true,
                    filterable: true
                }
            )
        ];
    }
}

export default InvestmentsPmiFundPanelCollection;
